import * as utils from '../utils';

export default async (cardUuid: string, type: string): Promise<utils.IProviderResponse<Record<string, any>>> => {
  const url = `${process.env.REACT_APP_REST_API_ADDRESS}/api/v1/mobigrams/${cardUuid}/${type === 'n' ? 'mark_as_opened_admin_url' : 'mark_as_opened'}`;

  const response = await fetch(url, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((res) => res.json());

  if (response.success !== true) {
    return utils.ResponseError('Failed to mark as opened. Please try again later.');
  }

  const result = {
    response,
  };

  return utils.ResponseData(result);
};
